import React, { type ReactNode } from 'react';
import { LinkItem } from '@atlaskit/menu';
import { Box, Inline } from '@atlaskit/primitives';

type RecommendationMenuItemProps = {
	title: string;
	lozenge?: ReactNode;
	iconBefore: ReactNode;
	onClick: () => void;
	description: string;
};

export const RecommendationMenuItem = ({
	iconBefore,
	onClick,
	title,
	lozenge = null,
	description,
}: RecommendationMenuItemProps) => (
	<LinkItem iconBefore={iconBefore} onClick={onClick} description={description} href="#">
		<Inline space="space.100">
			{title}
			{lozenge && <Box>{lozenge}</Box>}
		</Inline>
	</LinkItem>
);
